import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import {
  getReadyGarmentToSendToStore,
  getStoreByWarehouseInfo,
  getWarehouseGarmentsByStatus,
  postSendToStore,
  toGenerateChallanFromWarehouse,
} from "../../services/warehouse/WarehouseProcess";
import ConfirmStoreChange from "./ConfirmStoreChange";

import addItemSound from '../../assets/sounds/warehousesound3.mp3';

const SendToStore = () => {
  const navigate = useNavigate();
  const { warehouseData, brandProfileData } = getUserData();

  let enabledRfIdModal = brandProfileData.enabledRfIdModal;
  
  const audioRef = useRef(new Audio(addItemSound));
  const handleAddItem = () => {
    const audio = audioRef.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };

  let warehouseId = warehouseData.id;
  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState({});
  const [qrCodes2, setQrCodes2] = useState({});
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [storeValue, setStoreValue] = useState("");
  const [searchByInvoiceMethod, setSearchByInvoiceMethod] = useState(false);
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [isSaveButtonPressed, setIsSaveButtonPressed] = useState(false);
   const [searchMethod, setSearchMethod] = useState(true);
    const [qrMethod, setQrMethod] = useState(false);
    const [rfidMethod, setRfidMethod] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const getInvoiceNo = (qrCode) => qrCode.split("OI")[0];

  const [changeQrMethod, setChangeQrMethod] = useState(false);
  const [searchTermFocus, setSearchTermFocus] = useState("");
  const inputRef = useRef(null);
  const [changeScannerMethod, setChangeScannerMethod] = useState(false);

  const [dataProvider, setDataProvider] = useState([]);
  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);

  const [confirmStoreChangeModalVisible, setConfirmStoreChangeModalVisible] =
    useState(false);

  let qrCodeMap = new Map();
  const fetchData = (data) => {
    getWarehouseGarmentsByStatus(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          response.data.forEach((element) => {
            let garmentInfo = {
              garmentName: element.garmentName,
              garmentPack: element.garmentPack || "",
              storeCode: element.storeCode,
              id: element.id,
              rfid: element.rfid,
              createdDate: element.createdDate,
            };
            qrCodeMap.set(element.qrCode, garmentInfo);
          });
          setQrCodes(qrCodeMap);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  let qrCodeMap2 = new Map();
  const fetchData2 = (data) => {
    getWarehouseGarmentsByStatus(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          response.data.forEach((element) => {
            let garmentInfo = {
              garmentName: element.garmentName,
              garmentPack: element.garmentPack || "",
              storeCode: element.storeCode,
              id: element.id,
              rfid: element.rfid,
            };
            qrCodeMap2.set(element.qrCode, garmentInfo);
          });
          setQrCodes2(qrCodeMap2);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreData = () => {
    getStoreByWarehouseInfo(warehouseId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeData = response.data.map((item) => ({
            name: item.store.storeName,
            value: item.id, // store.id
          }));
          setStoreList(storeData);
          const data2 = {
            status: ["READY_TO_SEND_TO_STORE_BY_WARE_HOUSE"],
            storeWareHouseIds: response.data.map((item) => (item.id))
          };
          fetchData2(data2);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreData();
  }, []);

  
  
  const groupByInvoice = (data) => {
    const groups = {};

    data.forEach((item) => {
      const invoice = getInvoiceNo(item.qrCode);

      if (!groups[invoice]) groups[invoice] = [];
      groups[invoice].push(item);
    });

    return groups;
  };

  const handleScanAll = (items) => {
    const allItems = items.map((item) => ({
      garmentName: item.garment.garmentName,
      garmentPack: item.garment?.garmentPack || "",
      storeCode: item.garment.storeCode,
      id: item.garment.id,
      qrCode: item.qrCode,
      rfid: item.garment.rfid,
      createdDate: item.garment.createdDate,
    }));

    const newQrCodes = allItems.filter(
      (obj) => !selectedQrCodesChecked.includes(obj.qrCode)
    );

    setSelectedQrCodes((prev) => [...prev, ...newQrCodes]);
    setDataProvider((prev) => [...prev, ...newQrCodes]);
    setSelectedQrCodesChecked((prev) => [
      ...prev,
      ...newQrCodes.map((i) => i.qrCode),
    ]);

    handleAddItem();
  };


  const receiveDataFromConfirmModal = ({ success }) => {
    if (success) {
      setSelectedQrCodes([]);
      setSelectedQrCodesChecked([]);
      setDataProviderSuggestion([]);
      setSearchTerm("");
      setStoreValue("");
    }
  };

  const handleStoreChange = (selectedItem) => {
    if (selectedQrCodes.length > 0) {
      setConfirmStoreChangeModalVisible(true);
    } else {
      setStoreValue(selectedItem);
      const data = {
        status: ["PROCESSED", "UNPROCESSED"],
        storeWareHouseIds: [selectedItem],
      };
      setDataProviderSuggestion([]);
      setSearchTerm("");
      fetchData(data);
    }
  };
  
  const handleClearSearch = () => {
    setSearchTermFocus("");
    setAlreadyPresentData("");
  };

  const [alreadyPresentData, setAlreadyPresentData] = useState("");

  const refocusInput = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Refocus the input
      }
    }, 10); // Add slight delay to ensure it focuses after processing
  };

  const handleScan = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");
      // Ensure data exists
      if (qrCodes.has(data)) {
        setSearchTermFocus("");
        if (!selectedQrCodesChecked.includes(data)) {
          let scannedData = {
            garmentName: qrCodes.get(data).garmentName,
            garmentPack: qrCodes.get(data)?.garmentPack || "",
            storeCode: qrCodes.get(data).storeCode,
            id: qrCodes.get(data).id,
            rfid: qrCodes.get(data).rfid,
            createdDate: qrCodes.get(data).createdDate,
            qrCode: data,
          };
          setSelectedQrCodes([...selectedQrCodes, scannedData]);
          setDataProvider([...selectedQrCodes, scannedData]);
          handleAddItem()
          setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

  const handleScanRFID = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");

      // Check if RFID is already scanned before doing anything
      if (selectedQrCodesChecked.includes(data)) {
        setAlreadyPresentData(`Tag ${data} already exists.`);
        refocusInput();
        setSearchTermFocus("");
        return; // Stop further processing
      }

      // Find the entry in the map where the RFID matches the scanned value
      const garmentEntry = [...qrCodes.entries()].find(
        ([_, value]) => value.rfid === data
      );

      if (garmentEntry) {
        const [qrCode, garmentInfo] = garmentEntry;

        // Check if it’s already selected
        if (!selectedQrCodesChecked.includes(qrCode)) {
          let scannedData = {
            garmentName: garmentInfo.garmentName,
            garmentPack: garmentInfo?.garmentPack || "",
            storeCode: garmentInfo.storeCode,
            id: garmentInfo.id,
            rfid: garmentInfo.rfid,
            createdDate: garmentInfo.createdDate,
            qrCode,
          };
          setSelectedQrCodes([...selectedQrCodes, scannedData]);
          setDataProvider([...selectedQrCodes, scannedData]);
          handleAddItem();
          setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      } else {
        console.warn(`Scanned RFID ${data} not found in QR code map.`);
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

  useEffect(() => {
    if (!searchTerm) {
      setDataProviderSuggestion([]);
    } else {
      const suggestions = [];
      qrCodes.forEach((garment, qrCode, storeCode) => {
        if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
          suggestions.push({ qrCode, garment, storeCode });
        }
      });

      setDataProviderSuggestion(suggestions);
    }
  }, [searchTerm]);

   const renderSearchedByInvoiceTagItem = () => {
     if (!qrCodes || qrCodes?.length === 0) return null;

     // --- FILTER BY TODAY ---
     const today = new Date().toISOString().split("T")[0];

     const suggestions = [];
     qrCodes?.forEach((garment, qrCode) => {
      //  if (today === garment.createdDate?.split("T")[0]) {
         suggestions.push({ qrCode, garment });
      //  }
     });

     if (suggestions.length === 0) return <div>No data for today</div>;

     // Group the filtered data
     const groupedData = groupByInvoice(suggestions);

     return (
       <>
         {Object.keys(groupedData).map((invoiceNo) => (
           <div key={invoiceNo} className="mb-2 border-b pb-2">
             <div className="flex justify-content-between items-center bg-gray-100 px-2 py-2">
               <div className="text-xl font-bold">{invoiceNo}</div>

               <div
                 onClick={() => handleScanAll(groupedData[invoiceNo])}
                 className="cursor-pointer text-right"
               >
                 <img
                   src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                   style={{ width: "40%" }}
                 />
               </div>
             </div>

             {/*groupedData[invoiceNo].map((item, index) => {
            const isSelected = selectedQrCodesChecked.includes(item.qrCode);

            return (
              <div
                key={index}
                onClick={() => handleScan({ data: item.qrCode })}
                className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
              >
                <p className="flex-1 text-lg">{item.qrCode}</p>

                <p className="flex-1 text-lg">
                  {item.garment.garment.replace(/_/g, " ").substring(0, 20)}
                  {item.garment.garment.length > 20 ? "..." : ""}
                </p>

                <div className="flex-1 text-right">
                  {isSelected ? (
                    <img
                      src="Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      style={{ width: "10%" }}
                    />
                  ) : (
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                      style={{ width: "10%" }}
                    />
                  )}
                </div>
              </div>
            );
          })*/}
           </div>
         ))}
       </>
     );
   };

  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes.forEach((garment, qrCode, storeCode) => {
      if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({ qrCode, garment, storeCode });
      }
    });

    const newQrCodes = suggestions.filter(
      (item) => !selectedQrCodesChecked.includes(item.qrCode)
    );

    const updatedSelectedQrCodes = [
      ...selectedQrCodes,
      ...newQrCodes.map((item) => ({
        garmentName: item.garment.garmentName,
        garmentPack: item.garment?.garmentPack || "",
        storeCode: item.garment.storeCode,
        id: item.garment.id,
        qrCode: item.qrCode,
        rfid: item.garment.rfid,
        createdDate: item.garment.createdDate,
      })),
    ];

    setSelectedQrCodes(updatedSelectedQrCodes);
    setDataProvider(updatedSelectedQrCodes);

    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map((item) => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
  };

  const removeTag = (data) => {
    const updatedTag = selectedQrCodes.filter(
      (item) => item.qrCode !== data.qrCode
    );
    setSelectedQrCodes(updatedTag);
    setDataProvider(updatedTag);
    setSelectedQrCodesChecked(
      selectedQrCodesChecked.filter((code) => code !== data.qrCode)
    );
  };

  const handleRemoveAllSelectedData = () => {
    // Clear all selected QR codes and checked items
    setSelectedQrCodes([]);
    setSearchTerm("");
    setSelectedQrCodesChecked([]);

    // Reset the dataProvider to an empty state
    setDataProvider([]);

    // Optionally, reset the suggestions dataProvider
    setDataProviderSuggestion([]);
  };

  const handleReadyToSendToWarehouse = () => {
    // Check if the button has already been pressed
    if (selectedQrCodes.length > 0 ) {
      if (!isSaveButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSaveButtonPressed(true);
        const data = {
          qrCodeIdList: selectedQrCodes.map(qr => qr.id),
          status: 'READY_TO_SEND_TO_STORE_BY_WARE_HOUSE',
        };


        getReadyGarmentToSendToStore(warehouseId, data) // warehouseId
          .then(response => {
            if (!response.data.error) {
              const Res = response.data;
              const message = Res.message;
              const success = Res.status;
              if (success === true) {
                setModalVisible(true);
                setModalStatus('success');
                setModalText(message);
                setTimeout(() => {
                  navigate('/ReadyToSendToStoreByWareHouse');
                }, 1500);
              } else {
                setModalVisible(true);
                setModalStatus('not Success');
                setModalText(message);
                setTimeout(() => {
                  navigate('Home');
                }, 1500);
              }
            }
          })
          .catch(err => {
            console.error('Error:', err);
          });
      }
    } else {
      navigate('/ReadyToSendToStoreByWareHouse');
    }
     
  };

  const handleSendToStore = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      const data = {
        qrCodeIdList: selectedQrCodes.map((qr) => qr.id),
        status: "READY_TO_SEND_TO_STORE_BY_WARE_HOUSE",
      };
      getReadyGarmentToSendToStore(warehouseId, data) // warehouseId
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const message = Res.message;
            const success = Res.status;
            if (success === true) {
              toGenerateChallanFromWarehouse(storeValue)
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    const data = {
                      qrCodeInfoList: selectedQrCodes.map((item) => ({
                        id: item.id,
                      })),
                      wareHouseStoreChallanDTO: response.data,
                    };
                    postSendToStore(warehouseId, data)
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          const message = Res.message;
                          const success = Res.status;
                          if (success === true) {
                            setModalVisible(true);
                            setModalStatus("success");
                            setModalText(message);
                            setTimeout(() => {
                              navigate("/");
                            }, 1500);
                          } else {
                            setModalVisible(true);
                            setModalStatus("not Success");
                            setModalText(message);
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
              const data = {
                status: ["PROCESSED"],
              };
              fetchData(data);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-md font-normal ">{item.qrCode}</p>
        <p className="flex-1 text-md font-normal ">
          {(item.garmentName?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garmentName + "").length > 20 ? "..." : ""}
        </p>
        <p className="flex-1 text-md font-normal capitalize">
          {(item.storeCode?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.storeCode + "").length > 20 ? "..." : ""}
        </p>
        <p className="flex-1 text-md font-normal ">
          {(item.garmentPack?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garmentPack + "").length > 20 ? "..." : ""}
        </p>
        <div
          onClick={() => removeTag(item)}
          className="text-md font-normal text-right cursor-pointer"
        >
          <img
            src={
              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
            }
            style={{ width: "90%" }}
          />
        </div>
      </div>
    ));
  };

  const renderSearchedTagItem = () => {
    return dataProviderSuggestion?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrCode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrCode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-md font-normal ">{item.qrCode}</p>
          <p className="flex-1 text-md font-normal ">
            {(item.garment.garmentName?.replace(/_/g, " ") + "").substring(
              0,
              20
            )}
            {(item.garment.garmentName + "").length > 20 ? "..." : ""}
          </p>
          <p className="flex-1 text-md font-normal capitalize">
            {(item.garment.storeCode?.replace(/_/g, " ") + "").substring(
              0,
              20
            )}
            {(item.garment.storeCode + "").length > 20 ? "..." : ""}
          </p>
          <p className="flex-1 text-md font-normal ">
            {(item.garment?.garmentPack?.replace(/_/g, " ") + "").substring(0, 20)}
            {(item.garment?.garmentPack + "").length > 20 ? "..." : ""}
          </p>

          <div
            className="text-md font-normal text-right"
            style={{ width: "50px", minWidth: "50px" }}
          >
            {isSelected ? (
              <img
                src="Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                style={{ width: 24, height: 24 }}
              />
            ) : (
              <img
                src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                style={{ width: 24, height: 24 }}
              />
            )}
          </div>
        </div>
      );
    });
  };

  const handleBackButton = () => {
    navigate("/");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
          pointerEvents:
            isSendButtonPressed || isSaveButtonPressed ? "none" : "auto",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div onClick={() => refocusInput()}>
                <p> </p>
              </div>
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Send To Store
              </p>
            </div>
            {qrCodes?.size > 0 && (
              <div
                className="flex justify-content-center align-items-center mr-3"
                style={{
                  // left: 28,
                  // position: "absolute",
                  // top: -10,
                  backgroundColor: "red",
                  borderRadius: 20,
                  minWidth: 36,
                  height: 36,
                }}
              >
                <p className=" text-lg text-white font-normal text-center">
                  {qrCodes?.size}
                </p>
              </div>
            )}

            <div
              onClick={() => {
                setSearchByInvoiceMethod(true);
                setSearchMethod(false);
                setQrMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  marginRight: 30,
                }}
              >
                <img
                  src={"Img/searchInvoice.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            <div
              onClick={() => {
                setSearchMethod(true);
                setQrMethod(false);
                setRfidMethod(false);
                setSearchByInvoiceMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,

                  marginRight: 30,
                }}
              >
                <i
                  className="pi pi-search"
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div
              onClick={() => {
                setQrMethod(true);
                setSearchMethod(false);
                setRfidMethod(false);
                setSearchByInvoiceMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center border-1 cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  backgroundColor: "#fff",

                  marginRight: 30,
                  borderColor: "#fff",
                }}
              >
                <img
                  src={"images/qr-code.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            {enabledRfIdModal && (
              <div
                onClick={() => {
                  setRfidMethod(true);
                  setQrMethod(false);
                  setSearchMethod(false);
                  setSearchByInvoiceMethod(false);
                  refocusInput();
                  setSearchTerm("");
                  setSearchTermFocus("");
                }}
                className="cursor-pointer"
              >
                <div
                  className="flex justify-content-center align-items-center cursor-pointer"
                  style={{
                    height: 32,
                    width: 32,
                    marginRight: 30,
                  }}
                >
                  <img
                    src={"images/rfid-tags.png"}
                    style={{ height: 38, width: 38 }}
                  />
                </div>
              </div>
            )}
            <div className="ml-3 flex justify-content-center align-items-center mr-4">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center cursor-pointer">
                <i
                  className="pi pi-shopping-bag"
                  style={{ fontSize: "27px", color: "#fff" }}
                  onClick={() => handleReadyToSendToWarehouse()}
                ></i>
                <div
                  style={{
                    right: 0,
                    position: "absolute",
                    top: 2,
                    backgroundColor: "red",
                    borderRadius: 20,
                    minWidth: 30,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className=" text-md text-white font-semibold text-center"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {selectedQrCodes.length > 0
                      ? "+" + selectedQrCodes.length
                      : qrCodes2.size}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-1 ">
        <div className="flex-1">
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <div
              className="w-full "
              style={{
                pointerEvents:
                  isSendButtonPressed || isSaveButtonPressed ? "none" : "auto",
              }}
            >
              <div className="mx-2 mt-2">
                <Dropdown
                  value={storeValue}
                  onChange={(e) => handleStoreChange(e.value)}
                  options={storeList}
                  placeholder="Select Store"
                  disabled={isSendButtonPressed}
                  optionLabel="name"
                  className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                />
              </div>
            </div>

            {storeValue === "" && (
              <div>
                <p className=" text-3xl mt-3 font-bold text-center">
                  Please select the store
                </p>
              </div>
            )}
          </div>
          {qrCodes.size > 0 && storeValue !== "" && (
            <div className="flex-1">
              {qrMethod && (
                <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                  <div className=" flex flex-1">
                    <IconField iconPosition="left" className="flex flex-1">
                      <InputIcon className="pi pi-search text-xl"></InputIcon>
                      <InputText
                        className="text-xl flex flex-1 py-1 px-5"
                        style={{ borderRadius: 30 }}
                        ref={inputRef}
                        value={searchTermFocus}
                        onChange={(e) => {
                          setSearchTermFocus(e.target.value);
                          handleScan({ data: e.target.value });
                        }}
                        placeholder="Scan QR Code"
                        showSoftInputOnFocus={false}
                        autoFocus={true}
                      />
                    </IconField>
                  </div>
                  {searchTermFocus && (
                    <div
                      className="flex justify-content-end align-items-center cursor-pointer"
                      onClick={() => handleClearSearch()}
                    >
                      <p
                        className="text-3xl font-bold ml-4"
                        style={{ color: "red" }}
                      >
                        X
                      </p>
                    </div>
                  )}
                </div>
              )}

              {enabledRfIdModal && rfidMethod && (
                <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                  <div className=" flex flex-1">
                    <IconField iconPosition="left" className="flex flex-1">
                      <InputIcon className="pi pi-search text-xl"></InputIcon>
                      <InputText
                        className="text-xl flex flex-1 py-1 px-5"
                        style={{ borderRadius: 30 }}
                        ref={inputRef}
                        value={searchTermFocus}
                        onChange={(e) => {
                          setSearchTermFocus(e.target.value);
                          handleScanRFID({ data: e.target.value });
                        }}
                        placeholder="Scan RFID Tag"
                        showSoftInputOnFocus={false}
                        autoFocus={true}
                      />
                    </IconField>
                  </div>
                  {searchTermFocus && (
                    <div
                      className="flex justify-content-end align-items-center cursor-pointer"
                      onClick={() => handleClearSearch()}
                    >
                      <p
                        className="text-3xl font-bold ml-4"
                        style={{ color: "red" }}
                      >
                        X
                      </p>
                    </div>
                  )}
                </div>
              )}
              {searchMethod && (
                <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                  <div className=" flex flex-1">
                    <IconField iconPosition="left" className="flex flex-1">
                      <InputIcon className="pi pi-search text-xl"> </InputIcon>
                      <InputText
                        placeholder="Search Invoice No."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="text-xl flex flex-1 py-1 px-5"
                        style={{ borderRadius: 30 }}
                      />
                    </IconField>
                  </div>
                  {dataProviderSuggestion?.length > 0 && (
                    <div
                      className="flex justify-content-center align-items-center cursor-pointer"
                      onClick={handleSelectAllSearchedData}
                    >
                      <img
                        src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                        style={{ width: "50%" }}
                      />
                    </div>
                  )}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  className="flex-1 text-2xl font-medium text-center"
                  style={{ color: "green" }}
                >
                  {alreadyPresentData}
                </p>
              </div>
              {qrMethod || rfidMethod ? (
                <div className="my-3">
                  <p className=" text-3xl  font-bold text-center">
                    Please Scan Tag
                  </p>
                </div>
              ) : dataProviderSuggestion?.length !== 0 ? (
                <div
                  style={{
                    pointerEvents:
                      isSendButtonPressed || isSaveButtonPressed
                        ? "none"
                        : "auto",
                  }}
                >
                  <div className="flex flex-row py-1 mx-2 justify-content-between">
                    <p className="flex-1 text-xl font-medium ">Tag</p>
                    <p className="flex-1 text-xl font-medium">Garment</p>
                      <p className="flex-1 text-xl font-medium">Store</p>
                      <p className="flex-1 text-xl font-medium">Packing</p>

                    <p className="text-xl font-medium text-right">
                      Add
                    </p>
                  </div>
                  <div style={{ overflowY: "auto", height: "68vh" }}>
                    {renderSearchedTagItem()}
                  </div>
                </div>
              ) : searchByInvoiceMethod ? (
                <div className="my-3">
                  <p className=" text-3xl  font-bold text-center">
                    Please Add Tag By Invoice
                  </p>
                </div>
              ) : (
                <div className="my-3">
                  <p className=" text-3xl  font-bold text-center">
                    Please Search Tag
                  </p>
                </div>
              )}

              {qrCodes?.length !== 0 && searchByInvoiceMethod && (
                <div
                  style={{
                    pointerEvents: isSendButtonPressed ? "none" : "auto",
                  }}
                >
                  <div className="flex flex-row py-1 mx-2 justify-content-between">
                    <p className="flex-1 text-2xl font-medium ">Invoice No.</p>
                    <p className="flex-1 text-2xl font-medium text-right">
                      Add
                    </p>
                  </div>
                  <div style={{ overflowY: "auto", height: "75vh" }}>
                    {renderSearchedByInvoiceTagItem()}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {storeValue !== "" && (
          <div
            className=" flex-1 surface-0"
            style={{
              "--surface-0": "#f2f2f2",
            }}
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Selected Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        style={{
                          pointerEvents:
                            isSendButtonPressed || isSaveButtonPressed
                              ? "none"
                              : "auto",
                        }}
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      pointerEvents:
                        isSendButtonPressed || isSaveButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-xl font-medium ">Tag</p>
                      <p className="flex-1 text-xl font-medium">Garment</p>
                        <p className="flex-1 text-xl font-medium">Store</p>
                        <p className="flex-1 text-xl font-medium">Packing</p>

                      <p className="text-xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "65vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <ConfirmStoreChange
                setConfirmStoreChangeModalVisible={
                  setConfirmStoreChangeModalVisible
                }
                confirmStoreChangeModalVisible={confirmStoreChangeModalVisible}
                sendDataToConfirmStoreChange={receiveDataFromConfirmModal}
              />
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div
                className="my-1 mx-2"
                style={{
                  pointerEvents:
                    isSendButtonPressed || isSaveButtonPressed
                      ? "none"
                      : "auto",
                }}
              >
                <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleSendToStore}
                      disabled={isSendButtonPressed}
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed ? "Sending..." : "Send"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                          style={{ width: 30 }}
                        />
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SendToStore;
